import {
  AuthAsState,
  OPEN_SIGNIN_AS_TEACHER_MODAL,
  CLOSE_SIGNIN_AS_TEACHER_MODAL,
  SET_SELECTED_TEACHER,
  GET_TEACHERS_START,
  GET_TEACHERS_SUCCESS,
  GET_TEACHERS_FAIL,
  SIGNIN_AS_TEACHER_START,
  SIGNIN_AS_TEACHER_SUCCESS,
  SIGNIN_AS_TEACHER_FAIL,
  LOGOUT_AS_START,
  LOGOUT_AS_SUCCESS,
  LOGOUT_AS_FAIL,
} from './types';
import { AnyAction } from 'redux';
import { RESET_REDUCERS } from '../auth/types';

const initState: AuthAsState = {
  loading: false,
  error: false,
  teacherModal: {
    opened: false,
    loading: false,
    error: false,
    selectedValue: null,
    teachers: [],
  },
};

export default function authAsReducer(
  state: AuthAsState = initState,
  action: AnyAction
): AuthAsState {
  switch (action.type) {
    // zarządzanie stanem modala
    case OPEN_SIGNIN_AS_TEACHER_MODAL:
      return {
        ...state,
        teacherModal: {
          ...state.teacherModal,
          opened: true,
        },
      };
    case CLOSE_SIGNIN_AS_TEACHER_MODAL:
      return {
        ...state,
        teacherModal: {
          ...state.teacherModal,
          opened: false,
          selectedValue: null,
          teachers: [],
        },
      };
    //ustawianie wybranego nauczyciela
    case SET_SELECTED_TEACHER:
      return {
        ...state,
        teacherModal: {
          ...state.teacherModal,
          selectedValue: action.payload.id,
        },
      };
    // pobieranie listy nauczycieli
    case GET_TEACHERS_START:
      return {
        ...state,
        teacherModal: {
          ...state.teacherModal,
          loading: true,
        },
      };
    case GET_TEACHERS_SUCCESS:
      return {
        ...state,
        teacherModal: {
          ...state.teacherModal,
          loading: false,
          teachers: [...action.payload.teachers]
        },
      };
    case GET_TEACHERS_FAIL:
      return {
        ...state,
        teacherModal: {
          ...state.teacherModal,
          loading: false,
          error: true,
        },
      };
    // logowanie jako nauczyciel
    case SIGNIN_AS_TEACHER_START:
      return {
        ...state,
        loading: true,
      };
    case SIGNIN_AS_TEACHER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SIGNIN_AS_TEACHER_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    // wylogowywanie do konta supernauczyciela
    case LOGOUT_AS_START:
      return {
        ...state,
        loading: true,
      };
    case LOGOUT_AS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case LOGOUT_AS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case RESET_REDUCERS:
      // reset danych stora
      return {
        ...initState,
      };
    default:
      return state;
  }
}
